export default __webpack_public_path__ + "static/media/background_bingo.7155d827.png";